//DOOR CANVASSES
import { store } from "../../index";
import * as actions from "../../actions";
import api from "../api";

const ERROR_TIMEOUT = 10000;

export const postDoorDataAction = (data) => {
  return api
    .post("/door-data-action/", data)
    .then((res) => res.data)
    .catch((err) => {
      console.warn(err);
      return err;
    });
};

export const getDoorsFilePreview = (filename) => {
  return api
    .get("/doors-file-preview", { filename, preview_length: 10 })
    .catch((error) => {
      console.warn(error);
    });
};

export const getS3SignedUrl = (filename) => {
  return api
    .get("/presigned-media-url", { filename, method: "PUT" })
    .catch((error) => {
      console.warn(error);
    });
};

export const createPass = (data) => {
  store.dispatch(actions.setCampaignDoorCanvassPassesLoading(true));
  store.dispatch(actions.setCampaignDoorCanvassPassesError(false));

  return api
    .post("doorcanvasspasses/", data)
    .then((response) => {
      store.dispatch(actions.setCampaignDoorCanvassPassesLoading(false));
      store.dispatch(actions.setCampaignDoorCanvassPassesError(false));
      return response.data;
    })
    .catch((err) => {
      console.error(err);
      store.dispatch(actions.setCampaignDoorCanvassPassesLoading(false));
      store.dispatch(actions.setCampaignDoorCanvassPassesError(true));
    });
};

export const pullCampaignDoorCanvasses = () => {
  store.dispatch(actions.setCampaignDoorCanvassesLoading(true));
  store.dispatch(actions.setCampaignDoorCanvassesError(false));

  return api
    .get("doorcanvasses/", {})
    .then((res) => {
      store.dispatch(actions.setCampaignDoorCanvassesLoading(false));
      store.dispatch(actions.setCampaignDoorCanvasses(res.data));
    })
    .catch((err) => {
      console.log(err);
      store.dispatch(actions.setCampaignDoorCanvassesError(true));
      setTimeout(
        () => store.dispatch(actions.setCampaignDoorCanvassesError(false)),
        ERROR_TIMEOUT
      );
    });
};

export const updateOrCreateDoorCanvass = (data) => {
  store.dispatch(actions.setCampaignDoorCanvassesLoading(true));
  store.dispatch(actions.setCampaignDoorCanvassesError(false));

  if (Object.keys(data).includes("id")) {
    return api
      .patch(`doorcanvasses/${data.id}/`, data)
      .then((res) => {
        const state = store.getState();
        const existing = state.doorCanvasses.data.find(
          (d) => d.id === res.data.id
        );
        const merged = {
          ...existing,
          ...res.data,
          statuses: res.data.statuses ?? existing?.statuses,
        };
        store.dispatch(actions.updateDoorCanvass(merged));
        store.dispatch(actions.setCampaignDoorCanvassesLoading(false));
        return res.data;
      })
      .catch((err) => {
        console.log(err);
        store.dispatch(actions.setCampaignDoorCanvassesError(true));
        setTimeout(
          () => store.dispatch(actions.setCampaignDoorCanvassesError(false)),
          ERROR_TIMEOUT
        );
        throw err;
      });
  }

  return api.post("doorcanvasses/", data).then((res) => {
    store.dispatch(actions.insertDoorCanvass(res.data));
    store.dispatch(actions.setCampaignDoorCanvassesLoading(false));
    return res.data;
  });
};

// DOOR CANVASS PASSES
export const pullCampaignDoorCanvassPasses = (params) => {
  store.dispatch(actions.setCampaignDoorCanvassPassesLoading(true));
  store.dispatch(actions.setCampaignDoorCanvassPassesError(false));

  return api
    .get("doorcanvasspasses/", params)
    .then((res) => {
      store.dispatch(actions.setCampaignDoorCanvassPassesLoading(false));
      store.dispatch(actions.setCampaignDoorCanvassPasses(res.data));
      return res.data;
    })
    .catch((err) => {
      console.log(err);
      store.dispatch(actions.setCampaignDoorCanvassPassesError(true));
      setTimeout(
        () => store.dispatch(actions.setCampaignDoorCanvassPassesError(false)),
        ERROR_TIMEOUT
      );
    });
};

export const pullDoorCrews = (params) => {
  store.dispatch(actions.setDoorCrewsLoading(true));
  store.dispatch(actions.setDoorCrewsError(false));

  return api
    .get("doorcrews/", params)
    .then((res) => {
      store.dispatch(actions.setDoorCrewsLoading(false));
      store.dispatch(actions.setDoorCrews(res.data));
    })
    .catch((err) => {
      console.log(err);
      store.dispatch(actions.setDoorCrewsError(true));
      setTimeout(
        () => store.dispatch(actions.setDoorCrewsError(false)),
        ERROR_TIMEOUT
      );
    });
};

export const createDoorCrew = (data) => {
  store.dispatch(actions.setDoorCrewsLoading(true));
  store.dispatch(actions.setDoorCrewsError(false));
  return api
    .post("doorcrews/", data)
    .then((res) => {
      store.dispatch(actions.insertDoorCrew(res.data));
      store.dispatch(actions.setDoorCrewsLoading(false));
      return res.data;
    })
    .catch((err) => {
      console.log(err);
      store.dispatch(actions.setDoorCrewsError(true));
      setTimeout(
        () => store.dispatch(actions.setCrewsError(false)),
        ERROR_TIMEOUT
      );
    });
};

export const updateDoorCrew = (id, data) => {
  store.dispatch(actions.setDoorCrewsLoading(true));
  store.dispatch(actions.setDoorCrewsError(false));

  return api
    .patch(`/doorcrews/${id}/`, data)
    .then((res) => {
      // the patch response may not include the nested seats array (it's a lean
      // serializer), so merge onto the existing crew rather than replacing it
      // wholesale -- otherwise seats gets wiped to undefined in redux and blows
      // up addTurfsToSeats on the next render.
      const state = store.getState();
      const existingCrew = state.doorCrews.data.find((d) => d.id === id);
      const updatedCrew = { ...existingCrew, ...res.data };

      store.dispatch(actions.updateDoorCrew(updatedCrew));
      store.dispatch(actions.setDoorCrewsLoading(false));
      return updatedCrew;
    })
    .catch((err) => {
      console.log(err);
      store.dispatch(actions.setDoorCrewsError(true));
      setTimeout(
        () => store.dispatch(actions.setDoorCrewsError(false)),
        ERROR_TIMEOUT
      );
      throw err;
    });
};

export const createDoorCrewCanvasser = (data) => {
  store.dispatch(actions.setDoorCrewsLoading(true));
  store.dispatch(actions.setDoorCrewsError(false));

  return api
    .post(`/doorcrewcanvassers/`, data)
    .then((res) => {
      const seatData = res.data;
      const state = store.getState();
      const crewId =
        typeof seatData.crew === "object" ? seatData.crew?.id : seatData.crew;
      const crew = state.doorCrews.data.find((d) => d.id === crewId);

      if (!crew) {
        console.error("Could not find updated crew in state", crewId, seatData);
        store.dispatch(actions.setDoorCrewsLoading(false));
        return null;
      }

      const updatedCrew = {
        ...crew,
        seats: [
          ...crew.seats,
          { ...seatData, crewcanvasser_id: seatData.id },
        ],
      };

      store.dispatch(actions.removeDoorCrew(crew.id));
      store.dispatch(actions.insertDoorCrew(updatedCrew));
      store.dispatch(actions.setDoorCrewsLoading(false));
      return updatedCrew;
    })
    .catch((err) => {
      console.log(err);
      store.dispatch(actions.setDoorCrewsError(true));
      setTimeout(
        () => store.dispatch(actions.setCrewsError(false)),
        ERROR_TIMEOUT
      );
    });
};

export const updateDoorCrewCanvasser = (id, changes) => {
  store.dispatch(actions.setDoorCrewsLoading(true));
  store.dispatch(actions.setDoorCrewsError(false));

  return api
    .patch(`/doorcrewcanvassers/${id}/`, changes)
    .then((res) => {
      let state = store.getState();
      let data = res.data;
      let crew = state.doorCrews.data.find((d) => d.id === data.crew);
      if (!crew) {
        console.error("Could not find updated crew in state");
      }

      store.dispatch(actions.removeDoorCrew(data.crew));
      crew.seats = crew.seats.map((seat) => {
        if (seat.id !== data.id) return seat;

        // DoorCrewCanvasserSerializer has no `roles` field -- DoorCrewViewSet.list()
        // builds it by hand from a separate join table, it's not a real model column
        // -- so this PATCH response never carries it, and blindly replacing the seat
        // with `data` would silently wipe out its roles (including the one we just
        // changed). Apply the roles diff we sent ourselves instead.
        let roles = seat.roles || [];
        if (changes.roles) {
          changes.roles.forEach((patch) => {
            roles = roles.filter((r) => r.id !== patch.id);
            if (!patch.delete) {
              roles = [...roles, { id: patch.id, name: patch.name }];
            }
          });
        }

        return { ...seat, ...data, roles };
      });

      store.dispatch(actions.insertDoorCrew(crew));
      store.dispatch(actions.setDoorCrewsLoading(false));

      return crew;
    })
    .catch((err) => {
      console.log(err);
      store.dispatch(actions.setDoorCrewsError(true));
      setTimeout(
        () => store.dispatch(actions.setCrewsError(false)),
        ERROR_TIMEOUT
      );
    });
};

export const deleteDoorCrew = (id) => {
  store.dispatch(actions.setDoorCrewsLoading(true));
  store.dispatch(actions.setDoorCrewsError(false));

  return api
    .delete(`/doorcrews/${id}/`)
    .then((res) => {
      store.dispatch(actions.removeDoorCrew(id));
      store.dispatch(actions.setDoorCrewsLoading(false));
      return true;
    })
    .catch((err) => {
      console.log(err);
      store.dispatch(actions.setDoorCrewsError(true));
      setTimeout(
        () => store.dispatch(actions.setCrewsError(false)),
        ERROR_TIMEOUT
      );
      return false;
    });
};

export const deleteDoorCrewCanvasser = (id) => {
  store.dispatch(actions.setDoorCrewsLoading(true));
  store.dispatch(actions.setDoorCrewsError(false));

  return api
    .delete(`/doorcrewcanvassers/${id}/`)
    .then((res) => {
      let state = store.getState();
      let crew = state.doorCrews.data.find(
        (d) => !!d.seats.map((s) => s.id).includes(id)
      );
      if (!crew) {
        console.error("Could not find updated crew in state");
      }

      store.dispatch(actions.removeDoorCrew(crew.id));
      crew.seats = crew.seats.filter((d) => d.id !== id);

      store.dispatch(actions.insertDoorCrew(crew));
      store.dispatch(actions.setDoorCrewsLoading(false));
      return crew || {};
    })
    .catch((err) => {
      console.log(err);
      store.dispatch(actions.setDoorCrewsError(true));
      setTimeout(
        () => store.dispatch(actions.setCrewsError(false)),
        ERROR_TIMEOUT
      );
      return {};
    });
};

export const getTurfCodes = () => {
  let state = store.getState();
  if (state.turfCodes.data.length) return;

  store.dispatch(actions.setTurfCodesError(false));
  store.dispatch(actions.setTurfCodesLoading(true));

  return api
    .get("/turfcodes/")
    .then((res) => {
      store.dispatch(actions.setTurfCodes(res.data));
    })
    .catch(() => {
      store.dispatch(actions.setTurfCodesError(true));
    })
    .then(() => {
      store.dispatch(actions.setTurfCodesLoading(false));
    });
};

export const createTurfNote = (turf) => {
  store.dispatch(actions.setSiteNotesLoading(true));
  store.dispatch(actions.setSiteNotesError(false));

  return api
    .post("/turfnotes/", turf)
    .then((res) => {
      store.dispatch(actions.setSiteNotesLoading(false));
      return res.data;
    })
    .catch((e) => {
      console.log("CAUGHT A TURFNOTE CREATE ERROR");
      store.dispatch(actions.setSiteNotesError("Note failed to create"));
      console.error(e);
      setTimeout(
        () => store.dispatch(actions.setSiteNotesError(false)),
        ERROR_TIMEOUT
      );
      store.dispatch(actions.setSiteNotesLoading(false));
      throw e;
    });
};

export const removeTurfNote = (turfnote_id) => {
  store.dispatch(actions.setSiteNotesLoading(true));
  store.dispatch(actions.setSiteNotesError(false));
  return api
    .patch(`turfnotes/${turfnote_id}/`, { is_active: false })
    .then((res) => {
      store.dispatch(actions.setSiteNotesLoading(false));
      return res.data;
    })
    .catch((e) => {
      store.dispatch(actions.setSiteNotesError("Note failed to delete"));
      console.error(e);
      setTimeout(
        () => store.dispatch(actions.setSiteNotesError(false)),
        ERROR_TIMEOUT
      );
      store.dispatch(actions.setSiteNotesLoading(false));
    });
};

export const createDistrictNote = (district) => {
  store.dispatch(actions.setSiteNotesLoading(true));
  store.dispatch(actions.setSiteNotesError(false));

  return api
    .post("/districtnotes/", district)
    .then((res) => {
      store.dispatch(actions.setSiteNotesLoading(false));
      return res.data;
    })
    .catch((e) => {
      console.log("CAUGHT A DISTRICTNOTE CREATE ERROR");
      store.dispatch(actions.setSiteNotesError("Note failed to create"));
      console.error(e);
      setTimeout(
        () => store.dispatch(actions.setSiteNotesError(false)),
        ERROR_TIMEOUT
      );
      store.dispatch(actions.setSiteNotesLoading(false));
      throw e;
    });
};

export const removeDistrictNote = (districtnote_id) => {
  store.dispatch(actions.setSiteNotesLoading(true));
  store.dispatch(actions.setSiteNotesError(false));
  return api
    .patch(`districtnotes/${districtnote_id}/`, { is_active: false })
    .then((res) => {
      store.dispatch(actions.setSiteNotesLoading(false));
      return res.data;
    })
    .catch((e) => {
      store.dispatch(actions.setSiteNotesError("Note failed to delete"));
      console.error(e);
      setTimeout(
        () => store.dispatch(actions.setSiteNotesError(false)),
        ERROR_TIMEOUT
      );
      store.dispatch(actions.setSiteNotesLoading(false));
    });
};
